import PropTypes from 'prop-types';
const createPropTypesAuthToken = (isRequired) => function createPropTypesAuthTokenLogic(props, propName, componentName) {
    const { [propName]: value } = props;
    if (isRequired && !value) {
        return new Error(`${propName} in ${componentName} is required but was null`);
    }
    if (typeof value !== 'object') {
        return new Error(`${propName} in ${componentName} should be an object`);
    }
    const { token } = value;
    if (token && typeof token !== 'string') {
        return new Error(`${propName}.token in ${componentName} should be a string`);
    }
    return null; // ok
};
export const PropTypesAuthToken = createPropTypesAuthToken(false);
PropTypesAuthToken.isRequired = createPropTypesAuthToken(true);
export const propId = () => PropTypes.oneOfType([PropTypes.string, PropTypes.number]);
export const propIdList = () => PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]));
export const propStr = () => PropTypes.string;
export const propStrList = () => PropTypes.arrayOf(PropTypes.string);
export const propNumber = () => PropTypes.number;
export const propFunc = () => PropTypes.func;
export const propFuncList = () => PropTypes.arrayOf(PropTypes.func);
export const propBool = () => PropTypes.bool;
export const propAny = () => PropTypes.any;
export const propOneOf = (oneOf) => PropTypes.oneOf(oneOf);
export const propOneOfType = (types) => PropTypes.oneOfType(types);
export const propShape = () => PropTypes.shape({});
export const propArrayShape = (shape = {}) => PropTypes.arrayOf(PropTypes.shape(shape));
export const propArrayOf = (of) => PropTypes.arrayOf(of);
export const propArrayStr = () => PropTypes.arrayOf(PropTypes.string);
export const propArrayNum = () => PropTypes.arrayOf(PropTypes.number);
export const propValidate = () => PropTypes.arrayOf(PropTypes.func);
export const propChildren = () => PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.object,
    PropTypes.node,
    PropTypes.string,
    PropTypes.func,
]);
/** router の props から渡される location 型 */
export const propLocation = () => PropTypes.exact({
    hash: propStr().isRequired,
    key: propStr().isRequired,
    pathname: propStr().isRequired,
    search: propStr().isRequired,
    state: propShape(),
}).isRequired;
/** router の props から渡される match 型 */
export const propMatch = () => PropTypes.exact({
    params: propShape().isRequired,
    url: propStr().isRequired,
});
/** router の props から渡される history 型 */
export const propHistory = () => PropTypes.exact({
    action: propStr().isRequired,
    navigateTo: propFunc().isRequired,
    push: propFunc().isRequired,
    replace: propFunc().isRequired,
});
export const FieldProps = {
    id: propStr().isRequired,
    input: propShape().isRequired,
    label: propChildren().isRequired,
    meta: propShape().isRequired,
    name: propStr(),
    placeholder: propStr().isRequired,
    type: propStr().isRequired,
    value: propStr(),
};
export const ModalProps = {
    hideModal: propFunc(),
};
export const ReduxFormProps = {
    error: propStr(),
    handleSubmit: propFunc().isRequired,
    invalid: propBool().isRequired,
    submitting: propBool().isRequired,
};
export const FinalFormProps = {
    errors: propShape().isRequired,
    form: propShape().isRequired,
    handleSubmit: propFunc().isRequired,
    invalid: propBool().isRequired,
    submitting: propBool().isRequired,
    values: propShape().isRequired,
};
